export default __webpack_public_path__ + "static/media/i-endereco.c9dff16a.png";